import React, { useEffect, useState } from "react";
import { fetchInvoiceLeaderDashboard } from "../../../../../services/BillingDashboardAPI";
import AccordionComponent from "../../../../../common/Accordion";
import DataTable from "../../../../../common/DataTable";
import TopLimitDropdown from "../../../../../common/TopLimitDropdown";
import { Form } from "react-bootstrap";

interface InvoiceLeaderBoardProps {
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
  filters: {
    teamId: string | number | null;
    clientId: string | number | null;
    currencyType: string;
    yearMonth: Date | null;
  };
}

type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};
const LEADER_RANK_HEADER: Header[] = [
  {
    key: "rank_No",
    label: "Rank",
    style: { width: "5%" },
  },
  {
    key: "clientName",
    label: "Client",
    style: { width: "20%" },
  },
  {
    key: "invoice_Count",
    label: "Invoices",
    style: { width: "15%" },
  },
  {
    key: "lineItem_Count",
    label: "Line Items",
    style: { width: "15%" },
  },
  {
    key: "currency",
    label: "Currency",
    style: { width: "15%" },
  },

  {
    key: "total_Amount",
    label: "Amount",
    style: { width: "15%" },
  },
];

const InvoiceLeaderBoardData: React.FC<InvoiceLeaderBoardProps> = ({
  openDropdown,
  setOpenDropdown,
  filters,
}) => {
  const [topCount, setTopCount] = useState<number>(5);
  const [topLabel, setTopLabel] = useState<string>("Top 5");
  const [leaderData, setLeaderData] = useState<any[]>([]);
  const [selectedCurrency, setSelectedCurrency] = useState<"INR" | "USD">(
    "USD",
  );

  const formatYearMonth = (date: Date | null) => {
    if (!date) return null;
    return date.toISOString().slice(0, 7); // YYYY-MM
  };

  const fetchLeaderData = async () => {
    try {
      const payload = {
        currencyType: selectedCurrency,
        yearMonth: formatYearMonth(filters.yearMonth),
        limit: topCount,
      };

      const response = await fetchInvoiceLeaderDashboard(payload);
      setLeaderData(response || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchLeaderData();
  }, [filters, topCount, selectedCurrency]);

  const handleTopChange = (value: number, label: string) => {
    setTopCount(value);
    setTopLabel(label);
  };

  const [caseSummaryKey, setCaseSummaryKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    if (caseSummaryKey === key) {
      return;
    }
    setCaseSummaryKey(key || "0");
  };

  const summaryAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={caseSummaryKey}
      onSelect={handleBodyAccordionSelect}
    />
  );

  return (
    <div className="bg-white rounded-lg shadow-md w-100 h-100 bs_accoridan">
      {summaryAccordion([
        {
          title: (
            <div
              className="d-flex align-items-center w-100"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="me-auto">Invoice Leaders Board</span>

              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center toggle-btn">
                  <span className="me-2">INR</span>

                  <Form.Check
                    type="switch"
                    id="currency-switch"
                    checked={selectedCurrency === "USD"}
                    onChange={(e) =>
                      setSelectedCurrency(e.target.checked ? "USD" : "INR")
                    }
                  />

                  <span className="me-2">USD</span>
                </div>
                <div className="invoiceleaderboard_popup">
                  <TopLimitDropdown
                    title={topLabel}
                    onSelect={handleTopChange}
                    show={openDropdown === "leaderData"}
                    onToggle={(isOpen) =>
                      setOpenDropdown(isOpen ? "leaderData" : null)
                    }
                  />
                </div>
              </div>
            </div>
          ),
          content: (
            <>
              <DataTable headers={LEADER_RANK_HEADER} rows={leaderData} />
            </>
          ),
        },
      ])}
    </div>
  );
};

export default InvoiceLeaderBoardData;
